<template>
  <b-modal v-model="isOpen" hide-footer hide-header size="lg">

		<div class="row">
			<div class="col-12" v-if="!isFormDisplay"><!--list-->
				<div class="text-end p-0">
					<b-button variant="secondary" @click="getPeddlrOptions" class="me-2">Refresh</b-button>
					<b-button variant="secondary" @click="addPeddlrOption">Add Option</b-button>
				</div>
				<div class="w-100 d-flex flex-column text-center p-0">
					<h5 class="pb-2">Peddlr Options</h5>

					<div class="table-responsive">
						<div class="table align-middle table-nowrap">
							<b-table
							:items="options"
							:fields="fields"
							responsive="sm"
							>
								<template #cell(datetime_modified)="data">
									{{ data.item.datetime_modified |  formatDate}}
								</template>
								<template #cell(option_value)="data">
									<p v-bind:title='data.item.option_value' @click="copyText(data.item.option_value)" style="cursor: copy;">
										{{data.item.option_value | truncator(20,'...')}}
									</p>
									<!-- <pre>{{ data.item.option_value | json }}</pre> -->
								</template>
								<template #cell(option_name)="data">
									<span @click="updatePeddlrOption(data.item)" class="c-pointer text-primary">{{ data.item.option_name}}</span>
								</template>
							</b-table>
						</div>
					</div>
				</div>
			</div><!--list-->
			<div class="col-12" v-else><!--form-->
				<div class="w-100 d-flex flex-column text-center p-0">
					<h5 class="pb-2">{{form.id == 0 ? "Add":"Update"}} Peddlr Options</h5>
				</div>
				<ValidationObserver v-slot="{ handleSubmit, reset }">
					<b-form @submit.prevent="handleSubmit(savePeddlrOptions)" @@reset.prevent="reset">
						<div class="row">
							<div class="col-md-12 mb-3">
								<label class="form-label small fw-bold">Option Names<span style="color: red">*</span></label>
								<validation-provider
								name="name"
								:rules="{required: true}"
								v-slot="validationContext" 
								class="w-50"
								>
								<b-form-input
									:class="{'is-invalid':getValidationState(validationContext) === false,'c-disabled':form.id > 0}"
									v-model="form.name"
									type="text"
									class="form-control"
									placeholder="Please enter option name"
									:disabled="form.id > 0"
								/>
								<b-form-invalid-feedback>
									{{ validationContext.errors[0] }}
								</b-form-invalid-feedback>
								</validation-provider>
							</div><!--end of option name-->
							<div class="col-md-12 mb-3">
								<label class="form-label small fw-bold">Option Value<span style="color: red">*</span></label>
								<validation-provider
								name="value"
								:rules="{required: true}"
								v-slot="validationContext" 
								class="w-50"
								>
								<b-form-textarea
									:class="{'is-invalid':getValidationState(validationContext) === false}"
									v-model="form.value"
									rows="3"
									max-rows="6"
									class="form-control"
									placeholder="Please enter option value.."
								/>
								<b-form-invalid-feedback>
									{{ validationContext.errors[0] }}
								</b-form-invalid-feedback>
								</validation-provider>
							</div><!--end of option value-->
							<div class="col-md-12 mb-3">
								<div class="form-check form-switch">
								<label class="form-check-label" for="flexSwitchCheckDefault">Auto Load</label>
								<input
									class="form-check-input"
									v-model="form.isAutoLoad"
									type="checkbox"
									id="flexSwitchCheckDefault"
								/>
								</div>
							</div><!--end active status-->
						</div>
						<b-button variant="secondary" class="me-2" type="submit">Save</b-button>
						<b-button variant="default" @click="isFormDisplay = false">Cancel</b-button>
					</b-form>
				</ValidationObserver>
			</div><!--form-->
		</div>
  </b-modal>
</template>

<script>
// import Swal from "sweetalert2";
import { maintenanceMethods } from "@/state/helpers"; 

export default {
	name: "peddlr-options",
	props: ["value"],
	data() {
		return {
			options: [],
			fields: [
				{key: "id", sortable: false, label: 'ID'},
				{key: "option_name", sortable: false, label: 'Name'},
				{key: "option_value", sortable: false, label: 'Value'},
				{key: "datetime_modified", sortable: false, label: 'Updated At'},
				{key: "autoload", sortable: false, label: 'Auto Load'},
			],
			isFormDisplay: false,
			form: {
				id		: 0,
				name	: null,
				value	: null,
				isAutoLoad: 1
			}
		};
	},
	computed: {
		isOpen: {
			get(){
				return this.value
			},
			set(value){
				this.$emit('input', value);
			}
		}
	},
	methods: {
		...maintenanceMethods,
		async getPeddlrOptions(){
			await this.actionPeddlrOption({
				action: "peddlr-options-list",
				body: []
			})
			.then((res) => {
				this.isFormDisplay = false;
				this.options = res["message"]
				console.log(res);
			}).catch((e)=>{
				console.log("error while getting list of peddlr option",e);
			});
		},
		async addPeddlrOption(){
			this.isFormDisplay = true;
			this.form =  {
				id		: 0,
				name	: null,
				value	: null,
				isAutoLoad: 1
			}
		},
		async updatePeddlrOption(data){
			this.isFormDisplay = true;
			this.form =  {
				id		: data.id,
				name	: data.option_name,
				value	: data.option_value,
				isAutoLoad: data.autoload
			}
		},
		async savePeddlrOptions(){
			await this.actionPeddlrOption({
				action: "save-peddlr-options",
				body: this.form
			})
			.then(async (res) => {
				console.log(res);
				await this.getPeddlrOptions();
			}).catch((e)=>{
				console.log("error while saving peddlr option",e);
			});
			console.log(":: Peddlr Options ::", JSON.stringify(this.form));
		},
		getValidationState({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null;
		},
		async copyText(value) {
			try {
				await navigator.clipboard.writeText(value);
				alert("Text copied to clipboard");
			} catch (err) {
				console.error("Failed to copy: ", err);
				alert("Failed to copy text. Please try again.");
			}

		},
	},
	async mounted() {
		await this.getPeddlrOptions();
	}
}
</script>

<style>
.font-bold {
	font-weight: bold;
}

.fs-15 {
	font-size: 16px;
}

.user-icon {
  width: 120px;
  height: auto;
}

.fs-18 {
  font-size: 18px;
}
</style>